<template>
  <span class="member-nav-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path :d="path" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>
<script>
const paths = {
  tj: 'M4 19V9m6 10V5m6 14v-7m4 7H2',
  sc: 'M4 7h16v12H4zM8 4h8l2 3H6zM9 12h6',
  fl: 'M12 20s-7-4.3-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.7-7 10-7 10z',
  dy: 'M18 8a6 6 0 00-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
  cz: 'M4 6h16v12H4zM4 10h16M8 15h3',
  mg: 'M4 5h16v14H4zM4 7l8 6 8-6',
  rc: 'M12 3v18M7 7.5C7 5.6 9 5 12 5s5 .6 5 2.5-2 2.5-5 2.5-5 1-5 3 2 3 5 3 5-.6 5-2.5',
  tx: 'M12 3v13M7 11l5 5 5-5M5 21h14',
  in: 'M5 4h14v16H5zM8 8h8M8 12h8M8 16h5',
  hp: 'M12 21a9 9 0 100-18 9 9 0 000 18M9.8 9a2.3 2.3 0 114.2 1.3c-.7 1-2 1.2-2 2.7M12 17h.01',
  et: 'M10 5H5v14h5M14 8l4 4-4 4M8 12h10'
}
export default {
  name: 'MemberNavIcon',
  props: {name: {type: String, default: 'in'}},
  computed: {path () { return paths[this.name] || paths.in }}
}
</script>
